function idOf(value) {
  return value && value._id ? String(value._id) : String(value || "");
}

function slugify(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export default {
  activeProjects(state, getters, rootState) {
    const projectTypeIds = new Set(
      (state.GlobalAll || [])
        .filter(item => item && item.typeOf === "locationTypes" && item.value === "project")
        .map(item => String(item._id))
    );

    const locationProjects = (rootState.location?.Locations || [])
      .filter(location => {
        const active = location.active !== false && location.active !== 0 && location.active !== "false";
        return active && projectTypeIds.has(idOf(location.type));
      })
      .slice();
    // Users may only see descendant locations. The authorized project endpoint
    // also resolves their parent project without granting access to its tree.
    const projects = new Map(locationProjects.map(project => [idOf(project), project]));
    (state.accessibleProjects || []).forEach(project => {
      if (!projects.has(idOf(project))) projects.set(idOf(project), project);
    });
    return [...projects.values()]
      .sort((left, right) => String(left.name || "").localeCompare(String(right.name || ""), "de"));
  },
  selectedProject(state, getters) {
    return getters.activeProjects.find(project => String(project._id) === String(state.selectedProjectId || "")) || null;
  },
  projectSlug() {
    return project => slugify(project?.name);
  },
  selectedProjectSlug(state, getters) {
    return getters.projectSlug(getters.selectedProject);
  },
  projectLocationIds(state, getters, rootState) {
    const childrenByParent = new Map();
    (rootState.location?.Locations || []).forEach(location => {
      const parentId = idOf(location.parent);
      if (!childrenByParent.has(parentId)) childrenByParent.set(parentId, []);
      childrenByParent.get(parentId).push(String(location._id));
    });

    return projectOrId => {
      const projectId = idOf(projectOrId);
      const result = new Set();
      if (!projectId) return result;

      const pending = [projectId];
      while (pending.length) {
        const locationId = pending.pop();
        if (result.has(locationId)) continue;
        result.add(locationId);
        pending.push(...(childrenByParent.get(locationId) || []));
      }
      return result;
    };
  },
  selectedProjectLocationIds(state, getters) {
    return getters.projectLocationIds(getters.selectedProject);
  }
};
